import debounce from 'lodash.debounce';
import handlePlusQuantity from 'FORMS/handlePlusQuantity';
import handleSubtractQuantity from 'FORMS/handleSubtractQuantity';

const modal_breakpoint = 767;
let ws = window.innerWidth;

const product_card_selector = '[data-product-card]';
const product_price_selector = '[data-product-price]';
const product_price_compare = '[data-price-compare]';
const product_variation = '[data-product-variation]';
const add_quantity = '[data-add-quantity]';
const subtract_quantity = '[data-subtract-quantity]';
const buy_now = '[data-buy-now]';
const add_to_cart = '[data-add-to-cart]';

const variant_active_class = 'buy-active';

// Window resizing, update value
const updateWindowSize = debounce(() => (ws = window.innerWidth), 500);
window.addEventListener('resize', updateWindowSize);

document.addEventListener('click', closeAllActiveVariantStates);

// Assign all events to products cards showing on the page.
var products = document.querySelectorAll(product_card_selector);

products.forEach((item) => {
  assignProductCardEvents(item);
});

/**** Helper Functions ****/

/*
 * Assigns Events Listeners to all elements within the product card
 */
function assignProductCardEvents(item) {
  // Stop propagation of click events. Allows us to clear out of 'buy-active' state when click on body
  item.addEventListener('click', (e) => e.stopPropagation());

  // Buy Now --> Activates variant selector state
  item.querySelector(buy_now).addEventListener('click', toggleVariantState.bind(this, item));

  // Variant Select Buttons
  item.querySelectorAll(product_variation).forEach((variant) => {
    variant.addEventListener('click', handleVariantChange.bind(this, item));
  });

  item.querySelector(add_quantity).addEventListener('click', handlePlusQuantity.bind(this, item));
  item
    .querySelector(subtract_quantity)
    .addEventListener('click', handleSubtractQuantity.bind(this, item));

  item.querySelector(add_to_cart).addEventListener('click', handleAddToCart.bind(this, item));
}

/*
 * Toggles the variant purchase UI on the product vard
 */
function toggleVariantState(item, e) {
  e.preventDefault();
  if (ws <= modal_breakpoint) {
    window.openWyldModal(item.outerHTML);
  } else {
    item.classList.toggle(variant_active_class);
  }
}

/*
 * Maps target button from click event and parent item into single hanlder function
 */
function handleVariantChange(item, e) {
  const target = e.target;
  selectVariant(item, target);
}

/*
 * Selects a variant, prior to "adding to cart"
 */
function selectVariant(item, button) {
  // deselect all variants
  item
    .querySelectorAll(product_variation)
    .forEach((variant) => variant.classList.remove('selected'));

  // input hidden field
  const input = item.querySelector('input[type=hidden]');
  const price_container = item.querySelector(product_price_selector);
  const price_compare = item.querySelector(product_price_compare);

  // Product Id Value
  const id = button.dataset.productId;
  const amount =
    button.dataset.amount[0] === '$' ? button.dataset.amount : `$${button.dataset.amount}`;
  const compareamount =
    button.dataset.compareamount[0] === '$'
      ? button.dataset.compareamount
      : '$'.concat(button.dataset.compareamount);

  if (input !== null && typeof input !== 'undefined') {
    button.classList.add('selected');
    input.value = id;
    if (compareamount !== '$') {
      price_compare.innerText = compareamount;
    } else {
      price_compare.innerText = '';
    }
    price_container.innerText = amount;
  }
}

/*
 * Closes all active variant UIs, and resets the interfacee to default.
 */
function closeAllActiveVariantStates() {
  var products = document.querySelectorAll(product_card_selector);
  products.forEach((item) => {
    item.classList.remove(variant_active_class);
    Array.from(item.querySelectorAll(product_variation))
      .filter((button, i) => i === 0)
      .map((button) => selectVariant(item, button));
  });
}

function handleAddToCart(item, e) {
  e.preventDefault();
  var values = getFormValue(item);
  Shopify.addItem(values.id, values.quantity);
}

function getFormValue(item) {
  var elements = item.querySelector('form').elements;
  var obj = {};
  for (var i = 0; i < elements.length; i++) {
    var item = elements.item(i);
    obj[item.name] = item.value;
  }
  return obj;
}
